<template>
    <div>
        <div class="section-subtitle">
            <i class="icon icon-grid"></i
            ><span
                >{{ $t("app.links.budget_requests")
                }}<budget-forms-list :curFormSelect="'/form01-123'"
            /></span>
            <forms-download-reprt
                :progress="progress"
                :isReportUploading="isReportUploading"
                :form="form"
                :guListLen="guListLen"
                :header="header"
                :isParentGuExist="isParentGuExist"
                :isHeadGu="isHeadGu"
                :hasDeltaRep="true"
                @checkSignatories="checkSignatories"
                @downloadRep="downloadRep"
                @downloadBatchReports="downloadBatchReports"
                @downloadBatchReportsPaid="downloadBatchReportsPaid"
                @downloadDeltaRep="downloadDeltaRep"
            ></forms-download-reprt>
        </div>
        <div class="filter-container">
            <div class="left-content">
                <budget-header
                    v-show="categoryMode"
                    ref="budgetHeader"
                    :form="{ spf: form.spf }"
                    :specificProp="specificProp"
                    @chgData="changeHeader"
                    :yearReq="true"
                    :openDisabled="openDisabled"
                ></budget-header>
                <p v-if="!categoryMode" class="title">
                    {{ getCommonText("decoding") }}.
                    {{ cutString(currCategory[categoryFieldNames[lng]], 80) }}
                </p>
            </div>
            <div class="right-content">
                <template v-if="categoryMode">
                    <c-budget-forms-data-transfer
                        v-if="
                            !isGkkpMode && !(progress < 100) && variantAttribute
                        "
                        :header="header"
                        :lng="lng"
                        :getDataTransferText="getDataTransferText"
                        :getErrText="getErrText"
                        :makeToast="makeToast"
                        @reloadTable="loadCategoryData"
                    />
                    <div class="filter-actions filter-actions-flex">
                        <c-budget-forms-copy-rows
                            ref="cBudgetFormCopyRows"
                            v-if="
                                isCopyRowsBtnVisible &&
                                categoryMode &&
                                variantAttribute
                            "
                            :header="header"
                            :budgetForm="budgetForm"
                            :isHasDecodeTable="true"
                            :categoryFieldNames="categoryFieldNames"
                            :uuidv4="uuidv4"
                            :getErrText="getErrText"
                            :makeToast="makeToast"
                            @updtHeader="updtHeader"
                            @addItem="addItem"
                            @reloadTable="loadCategoryData"
                        />
                        <c-budget-forms-copy-data
                            v-if="
                                !(progress < 100) &&
                                variantAttribute &&
                                header.year < header.cur_year + 2
                            "
                            :budgetForm="budgetForm"
                            :header="header"
                            :isLoad="isLoad"
                            @keyPress="keyPress"
                        />
                        <b-button
                            variant="primary"
                            @click="onAddNewCat"
                            v-if="variantAttribute"
                            :disabled="isLoad"
                            ><i class="icon icon-plus-circle"></i>
                            {{ getCommonText("add") }}</b-button
                        >
                    </div>
                </template>
                <template v-else>
                    <b-button variant="light" @click="resetModal">
                        <i class="icon icon-keyboard icon-rotate-180"></i
                        >{{ getCommonText("back_to_list") }}
                    </b-button>
                    <b-button
                        :style="{ minWidth: '110px' }"
                        v-if="variantAttribute"
                        variant="primary"
                        @click="$refs.formTemplate.addItem()"
                    >
                        <i class="icon icon-plus-circle"></i
                        >{{ getCommonText("add") }}
                    </b-button>
                    <b-button
                        :style="{ minWidth: '110px' }"
                        :disabled="!isDataChanged || goodsAreSaving"
                        variant="success"
                        @click="prepareForSave"
                    >
                        {{ getCommonText("save") }}
                    </b-button>
                </template>
            </div>
        </div>

        <filter-empty-placeholder v-if="enteredFromOtherMode" />
        <template v-else>
        <div v-show="categoryMode" class="table-container">
            <b-overlay :show="isLoad" rounded="sm">
                <b-overlay :show="mainTableOverlay" rounded="sm">
                <b-table
                    :fields="tableFields"
                    :items="budgetForm"
                    responsive="true"
                    bordered
                    head-variant="light"
                    sticky-header="true"
                    no-border-collapse
                >
                    <template #top-row="data">
                        <td></td>
                        <td></td>
                        <td class="td-numbering text-center table-success">
                            1
                        </td>
                        <td class="td-numbering text-center table-danger">2</td>
                        <td class="td-numbering text-center table-info">3</td>
                        <td class="td-numbering text-center table-primary">
                            4
                        </td>
                        <td class="td-numbering text-center table-warning">
                            5
                        </td>
                        <td class="td-numbering text-center table-success">
                            6
                        </td>
                        <td class="td-numbering"></td>
                    </template>
                    <template #head(selection)>
                        <div class="text-center">
                            <b-form-checkbox
                                v-model="selectAll"
                                @change="(e) => setIsAllDelete(e)"
                                :value="true"
                                :unchecked-value="false"
                            />
                        </div>
                    </template>
                    <template #head(more)>
                        <div class="text-center">
                            <i
                                :title="getCommonText('del_selected')"
                                class="icon icon-close table-all-remove"
                                @click="
                                    deleteItem(
                                        `${
                                            selectAll
                                                ? getCommonText('all_cats')
                                                : getCommonText('selected_cats')
                                        }`
                                    )
                                "
                            />
                        </div>
                    </template>
                    <template #cell(selection)="data">
                        <div class="text-center">
                            <b-form-checkbox
                                v-model="data.item.itemToDelete"
                                @input="
                                    (e) => {
                                        selectCheckBoxClicked(e);
                                        if (!e) selectAll = false;
                                    }
                                "
                                :value="true"
                                :unchecked-value="false"
                            />
                        </div>
                    </template>
                    <template #cell(action)="data">
                        <div class="text-center">
                            <button
                                class="table-plus"
                                v-b-modal.goods-modal
                                @click="setCurrCatName(data.item)"
                                :disabled="
                                    !data.item.isRowValid ||
                                    data.item.nameUpdating
                                "
                            >
                                <i class="icon icon-plus-circle" />
                            </button>
                        </div>
                    </template>
                    <template #cell(name)="data">
                        <div class="column-width-100 bp-category-name">
                            <div>{{ data.item[categoryFieldNames[lng]] }}</div>
                            <i
                                v-if="variantAttribute"
                                class="icon icon-pencil-edit thin-blue ml-3 pointer icon-18"
                                @click="onEditCatName(data.item)"
                            ></i>
                        </div>
                    </template>
                    <template #cell(staff_num)="data">
                        <b-form-input
                            v-if="variantAttribute"
                            class="text-right"
                            :value="data.item.staff_num"
                            @change="(v) => { inputFixed(data.item, 'staff_num', v, 2); onCatDataChanged(data.item); }"
                            @keyup.enter.exact="keyup13"
                            @keypress="keyPress($event, '^\\d*\\.?\\d{0,9}$')"
                        >
                        </b-form-input>
                        <div v-else class="text-right">{{ $n(data.value) }}</div>
                        
                        <p
                            class="goods-form-val-msg"
                            v-if="variantAttribute  && (!isFieldValid(data.value))"
                        >
                            {{ getCommonText("positive") }}
                        </p>
                    </template>

                    <template #cell(norm_employee)="data">
                        <div 
                            class="text-right" 
                            :class="{'is_custom_norm': data.item.norm_employee > defaultNormEmployee}"
                            :title="data.item.norm_employee !== defaultNormEmployee ? defaultNormEmployee : null"
                            >
                            {{ $n(data.value) }}
                        </div>
                    </template>

                    <template #cell(norm_division)="data">
                        <b-form-input
                            v-if="variantAttribute"
                            class="text-right"
                            :value="data.item.norm_division"
                            @change="(v) => { inputFixed(data.item, 'norm_division', v, 0); onCatDataChanged(data.item); }"
                            @keyup.enter.exact="keyup13"
                            @keypress="keyPress($event, '^\\d*$')"
                        >
                        </b-form-input>
                        <div v-else class="text-right">{{ $n(data.value) }}</div>
                    </template>
                    <template #cell(total)="data">
                        <div class="text-right">{{ $n(data.value) }}</div>
                    </template>
                    <template #cell(files)="data">
                        <span
                            class="blue pointer underline"
                            @click="onAllFilesClick(data.item)"
                            >({{
                                data.item.files ? data.item.files.length : 0
                            }})</span
                        >
                    </template>
                    <template #cell(more)="data">
                        <div class="text-center">
                            <i
                                class="icon icon-clear table-remove"
                                v-if="variantAttribute"
                                :disabled="isLoad"
                                @click="
                                    deleteItem(
                                        getCommonText('curr_cat'),
                                        { ...data.item, good_type: data.item },
                                        data.index,
                                        true
                                    )
                                "
                            ></i>
                        </div>
                    </template>
                    <template #bottom-row="data">
                        <td class="text-right" colspan="6">
                            {{ getCommonText("total") }}
                        </td>
                        <td class="text-right">{{ $n(total) }}</td>
                        <td colspan="2"></td>
                    </template>
                </b-table>
                </b-overlay>
            </b-overlay>
            <div class="table-add" v-if="variantAttribute" :disabled="isLoad">
                <span @click="onAddNewCat"
                    ><i class="icon icon-plus-circle"></i>
                    {{ getCommonText("add") }}</span
                >
            </div>
        </div>
        <template v-if="!categoryMode">
            <b-overlay :show="templateTableOverlay" rounded="sm">
                <form-template9
                    ref="formTemplate"
                    :goodsData="goodsData"
                    :header="header"
                    :initialGoodsData="initialGoodsData"
                    :calcFormCaptions="calcFormCaptionsDecode"
                    :ensTruDict="ensTruDict"
                    :variantAttribute="variantAttribute"
                    :currCategory="currCategory"
                    :lang="lang"
                    :ifAllFieldsFilled="ifAllFieldsFilled"
                    @deleteGood="deleteGood"
                    :ensTruNamePrt="ensTruNamePrt"
                    :ensTruName="ensTruName"
                    :descIsLoading="descIsLoading"
                    :parNameLoading="parNameLoading"
                    :allFiles="allFiles"
                    :isLoad="isLoad"
                    :triggDownloadFile="triggDownloadFile"
                    :triggDownloadAllFiles="triggDownloadAllFiles"
                    :showFileUploadModal="showFileUploadModal"
                    :getEnstruByName="getEnstruByName"
                    :goodsAreSaving="goodsAreSaving"
                    :isDoubleDecodeExist="isDoubleDecodeExist"
                    :isFieldValid="isFieldValid"
                    @setDataChanged="setDataChanged"
                    @setItemTotal="setItemTotal"
                    @searchName="searchName"
                    @setIsAllDelete="setIsAllDelete"
                    @decodeDataValidation="isDecodeDataValid"
                    @doublesValidationDecodes="doublesValidationDecodes"
                    @addGoodsOrderNum="addGoodsOrderNum"
                ></form-template9>
                <div class="table-add" v-if="variantAttribute">
                    <span @click="$refs.formTemplate.addItem()"
                        ><i class="icon icon-plus-circle"></i>
                        {{ getCommonText("add") }}</span
                    >
                </div>
            </b-overlay>
        </template>
        <files-updown 
            v-if="isFilterReady"
                      ref="filesUpdown"
            v-show="categoryMode"
            :header="header"
            :variant-attribute="variantAttribute"
            :variant-name="variantName ? variantName['pure_name_' + lng] : ''"
            :load="isLoad"
            :showDeleteLinks="variantAttribute"
            :showDeleteAll="true"
            @getFiles="getFiles"
            @fillFilesList="fillFilesList"
            @restetFilesList="restetFilesList"
            @delelteAttachedFile="delelteAttachedFile"
            @onFilePreview="onFilePreview"
        ></files-updown>
        <modal-all-files-management
            ref="modalAllFilesManagement"
            :allFiles="allFiles"
            @triggDownloadFile="triggDownloadFile"
            @triggDownloadAllFiles="triggDownloadAllFiles"
        >
        </modal-all-files-management>
        <c-set-b-f-category-name
            ref="setCatNameModal"
            :budgetForm="budgetForm"
            :categoryFieldNames="categoryFieldNames"
            :lng="lng"
            :getCommonText="getCommonText"
            :maxNameLengthSymbls="500"
            @addItem="addItem"
            @onCatNameChanged="onCatDataChanged"
        />
        </template>
    </div>
</template>

<script>
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import BudgetHeader from "@/modules/budget-request/budget-header-new.vue";
import FilesUpdown from "@/modules/budget-request/FilesUpdown";
import BudgetFormsList from "@/modules/budget-request/components/budget-forms-list.vue";
import FormsHandlerMixin from "./mixins/forms-handler-mixin";
import { specificProp } from "./components/js/budgetFormsLst";
import FormTemplate9 from "./components/budget-forms-template9.vue";
import ModalAllFilesManagement from "./components/modal-all-files-management.vue";
import CBudgetFormsCopyData from "./components/budget-forms-copy-data.vue";
import FormsDownloadReprt from "./components/forms-download-reprt.vue";
import CSetBFCategoryName from "./components/c-set-bf-category-name.vue";
import CBudgetFormsCopyRows from "./components/budget-forms-copy-rows.vue";
import CBudgetFormsDataTransfer from "./components/budget-forms-data-transfer.vue";
import Decimal from "decimal.js";
import FilterEmptyPlaceholder from "@/modules/budget-request/components/filter-empty-placeholder.vue";

export default {
    name: "Form02_149_v2",
    components: {
        BudgetHeader,
        FilesUpdown,
        BudgetFormsList,
        FormsDownloadReprt,
        FormTemplate9,
        ModalAllFilesManagement,
        CBudgetFormsCopyData,
        CSetBFCategoryName,
        CBudgetFormsCopyRows,
        CBudgetFormsDataTransfer,
        FilterEmptyPlaceholder,
    },
    mixins: [FormsHandlerMixin],
    data() {
        return {
            form: {
                code: "02-149",
                spf: {
                    name: "149 - Приобретение прочих запасов",
                    spf: "149",
                },
            },
            includedCodePrefixes: ["1723", "329912", "329913", "329914", "329915"],
            isDataChanged: false,
            dataTypeFilter: null,
            variantAttribute: null,
            variantName: null,
            formFilter: null,
            budgetForm: [],
            header: null,
            files: null,
            openDisabled: false,
            isLoad: true,
            isReportUploading: false,
            specificProp: specificProp,
            categoryFieldNames: { ru: "name_ru", kk: "name_kk" },
            mrp: 0,
            // EAK-1626: третья форма (после пилотных 01-123, 133) - подписи граф основной
            // (категорийной) таблицы И вложенной расшифровки (budget-forms-template9.vue,
            // через prop calcFormCaptions) резолвятся из справочника
            // dict_calculation_form_captions (см. forms-handler-mixin.js,
            // loadCalcFormCaptions()), если там что-то заведено для form_code='02-149'.
            captionsEnabled: true,
            // 2 - вторая версия формы (dict_calculation_forms.version=2 для '02-149', в
            // отличие от 01-123/133 первой версии) - обязательна для резолва капшенов через
            // loadCalcFormCaptions().
            formVersion: 2,
        };
    },

    created() {
        this.$emit("setForm", this.form);
    },
    mounted() {
        this.progress = 15;
    },
    watch: {
        openDisabled() {
            this.$emit("setOpenDisabled", this.openDisabled);
        },
        categoryMode() {
            this.$emit("setCategoryMode", this.categoryMode);
        },
        progress() {
            this.$emit("setProgress", this.progress);
        }
    },
    methods: {
        itemUpdate(item, nameRu, nameKk) {
            this.$set(item, "name_ru", nameRu);
            this.$set(item, "name_kk", nameKk);
            this.$set(item, "category_id", this.uuidv4());
            this.$set(item, "staff_num", 0);
            this.$set(item, "norm_division", 0);
            this.$set(item, "total", 0);
            this.$set(item, "newCat", true);
            this.$set(item, "nameUpdating", false);
            this.$set(item, "itemToDelete", false);
            this.$set(item, "oldName", nameRu);
            this.$set(item, "oldName_kk", nameKk);
            this.$set(item, "isRowValid", false);

            this.addGetNormEmployee(item);

        }, // заполнение полей при добавлении новой категории

        async loadCategoryData() {
            this.selectAll = false;
            this.setIsCopyRowsBtnVisible(false);
            this.isLoad = true;
            this.budgetForm.splice(0);
            const data = { ...this.header, form_version: this.header.form + "_v2" };
            try {
                const response = await fetch(
                    "/api-py/get-budget-request-form-cat/" +
                        JSON.stringify(data)
                );
                if (response.status === 200) {
                    const values = await response.json();
                    values.forEach((val, i) => {
                        const item = {
                            id: val.id,
                            name_ru: val.name_ru,
                            name_kk: val.name_kk,
                            category_id: val.category_id,
                            staff_num: val.staff_num,
                            norm_division: val.norm_division,
                            total: val.total,
                            newCat: false,
                            oldName: val.name_ru,
                            oldName_kk: val.name_kk,
                            nameUpdating: false,
                            isRowValid: true,
                            files: this.getUnicFilesArr(val),
                            itemToDelete: false,
                        };
                        this.addGetNormEmployee(item);
                        this.budgetForm.push(item);
                    });
                
                }
            } catch (error) {
                this.makeToast(
                    "danger",
                    `${this.getErrText("bad_request")} loadCategoryData()`,
                    error.toString()
                );
            }
            this.isLoad = false;
            this.enableCopyRowsComponent();
        },

        addGetNormEmployee(item) {
            Object.defineProperty(item, "norm_employee", {
                get: () => {
                    if (item.staff_num > 0 && item.total > 0) {
                        const total = this.safeDecimal(item.total);
                        const staff_num = this.safeDecimal(item.staff_num);
                        const norm_division = this.safeDecimal(item.norm_division);
                        const itemTotal = total
                            .mul(1000)
                            .minus(norm_division)
                            .div(staff_num);
                        return itemTotal
                            .toDecimalPlaces(2, Decimal.ROUND_HALF_UP)
                            .toNumber();
                    } else return 0;
                },
            });
        },

        setItemTotal(item) {
            Object.defineProperty(item, "total", {
                get: () => {
                    const amount = this.safeDecimal(item.amount);
                    const cost = this.safeDecimal(item.cost);
                    const itemTotal = amount
                        .mul(cost)
                        .div(1000);
                    return itemTotal
                        .toDecimalPlaces(3, Decimal.ROUND_HALF_UP)
                        .toNumber();
                },
            });
        },

        
        inputFixed(item, field, value, digit, defaultVal = 0) {
            const newVal = parseFloat(value)
                ? parseFloat(parseFloat(value).toFixed(digit))
                : defaultVal;
            if (digit === 0) {
                const maxIntValue = 2147483647;
                if (newVal > maxIntValue) {
                    this.makeToast('danger', this.getErrText('warning'),  `max value ${maxIntValue}`);
                }
            }
            if (newVal !== item[field]) {
                this.$set(item, field, newVal);
                return "changed";
            }
            return "not changed";
        }, // форматирует введенное значение до digit цифр после запятой
    
        async save(values) {
            this.saveDecodes(values);
        },

        async saveDecodes(values) {
            this.isLoad = true;
            const dataToSave = {
                values,
                header: this.header
            }

            try {
                const url = '/api-py/save-brform02-149_v2-decode/'
                const response = await fetch(url, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json;charset=utf-8'
                    },
                    body: JSON.stringify(dataToSave)
                });
                const result = await response.json();
                if (response.status === 200) {
                    this.dataChanged = false;
                    this.loadGoodsData(this.currCategory);
                    this.updateDatas();
                    
                    this.selectAll = false;
                    this.makeToast('success', this.getErrText('msg'), this.getErrText('saved'));
                    this.deletingAgreementTotalResultHandler(result);
                } else {
                    this.goodsAreSaving = false;
                    throw this.getErrText('not_saved');
                }
            } catch (e) {
                this.goodsAreSaving = false;
                this.makeToast('danger', this.getErrText('warning'), e.toString());
            } finally {
                this.isLoad = false;
            }
        }, // сохранение данных

        async saveCategoryChanges(item) {
            this.setIsCopyRowsBtnVisible(false);
            this.isLoad = true;
            const data = {
                item: item,
                header: this.header,
            };
            try {
                const response = await fetch("/api-py/save-brform02-149_v2/", {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json;charset=utf-8",
                    },
                    body: JSON.stringify(data),
                });
                if (response.status === 200) {
                    const result = await response.json();
                    if ("result" in result && result["result"] == "success") {
                        if ("new_id" in result) {
                            this.$set(item, "id", result["new_id"]);
                        }
                    } else {
                        throw this.getErrText("not_saved");
                    }
                } else {
                    throw this.getErrText("not_saved");
                }
            } catch (e) {
                this.makeToast(
                    "danger",
                    this.getErrText("warning"),
                    e.toString()
                );
            } 
            this.selectAll = false;
            this.isLoad = false;
            this.enableCopyRowsComponent();
        },

        async loadGoodsData(cat) {
            if (!cat.category_id) return;
            this.templateTableOverlay = true;
            this.initialGoodsData = {};
            const newHeader = {
                ...this.header,
                cat_code: cat.category_id,
                form: "02-149_v2",
            };
            try {
                const response = await fetch(
                    "/api-py/get-budget-request-form-goods/",
                    {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json;charset=utf-8",
                        },
                        body: JSON.stringify(newHeader),
                    }
                );
                if (response.status === 200) {
                    const values = await response.json();
                    await this.ensTruDataAddingToGoods(values);
                    process.nextTick(() => {
                        values.forEach((val) => {
                            this.$set(val, "isNew", false);
                            this.$set(val, "rowToSave", false);
                            this.$set(
                                val,
                                "currGoodDesc",
                                this.ensTruName.filter(
                                    (ens) => ens.code === val.enstru_code
                                )[0]
                            );
                            this.$set(
                                val,
                                "ensTruName",
                                this.ensTruName.filter(
                                    (itm) =>
                                        itm["name_" + this.lang] === val.name
                                )
                            );
                            this.$set(val, "itemToDelete", false);
                            this.$set(val, "isHasDouble", false);
                            this.isDecodeDataValid(val);
                            this.setItemTotal(val);

                            this.initialGoodsData[val.id] = {
                                ...val,
                                total: val.total,
                            };
                        });
                        this.goodsData = values.sort((a, b) => a.id - b.id);
                        this.addGoodsOrderNum();
                        this.doublesValidationDecodes();
                        this.setDataChanged();
                    });
                }
            } catch (error) {
                this.makeToast(
                    "danger",
                    `${this.getErrText("bad_request")} loadGoodsData()`,
                    error.toString()
                );
            }
            this.templateTableOverlay = false;
            this.goodsAreSaving = false;
        }, // загрузка списка расшифровок
        
        deleteItem(msg, row = false) {
            if (
                !this.variantAttribute ||
                this.isLoad ||
                (!row &&
                    this.budgetForm.findIndex((itm) => itm.itemToDelete) === -1)
            )
                return;

            if (row) this.currCategory = row.category_id;

            this.$bvModal
                .msgBoxConfirm(
                    this.getCommonText("del_with_decodes", { msg: msg }),
                    {
                        title: this.getCommonText("confirm"),
                        size: "lg",
                        buttonSize: "sm",
                        okVariant: "danger",
                        okTitle: this.getCommonText("yes"),
                        cancelTitle: this.getCommonText("cancel"),
                        footerClass: "p-2",
                        hideHeaderClose: false,
                        centered: true,
                    }
                )
                .then(async (value) => {
                    if (value) {
                        if (row) {
                            if (row.id >= 0) {
                                this.deleteRows([row], "category");
                            }
                            const idxToDel = this.budgetForm.findIndex(
                                (itm) => itm.id === row.id
                            );
                            this.budgetForm.splice(idxToDel, 1);
                        } else {
                            const existingRowsToDel = this.budgetForm.filter(
                                (item) => item.id >= 0 && item.itemToDelete
                            );
                            this.budgetForm = this.budgetForm.filter(item => !item.itemToDelete);

                            if (!existingRowsToDel.length) {
                                this.selectAll = false;
                            } else {
                                await this.deleteRows(
                                    existingRowsToDel,
                                    "category"
                                );
                            }
                        }
                    }
                })
                .catch((error) => {
                    this.makeToast(
                        "danger",
                        this.getCommonText("on_del"),
                        error.toString()
                    );
                });
        },

        async deleteRows(items, mode) {
            this.isLoad = true;
            const data = {
                item: items,
                header: this.header,
                mode: mode,
                form: this.header.form_version,
            };
            try {
                const response = await fetch(
                    "/api-py/delete-list-budget-request-form/",
                    {
                        method: "DELETE",
                        headers: {
                            "Content-Type": "application/json;charset=utf-8",
                        },
                        body: JSON.stringify(data),
                    }
                );
                if (response.ok) {
                    this.makeToast(
                        "success",
                        this.getErrText("msg"),
                        this.getErrText("one_deleted")
                    );
                }
            } catch {
                this.makeToast(
                    "danger",
                    this.getErrText("warning"),
                    this.getErrText("on_del")
                );
            }
            this.isLoad = false;
        }, // удаление данных
        
        addGoodsOrderNum() {
            this.goodsData.forEach((item, i) => {
                this.$set(item, "order_num", i+1)
            }) 
        },

        fillDataForSave(item, row) {
            this.$set(item, "category_id", this.currCategory.category_id);
            this.$set(item, "name_ru", this.currCategory.name_ru);
            this.$set(item, "name_kk", this.currCategory.name_kk);
            this.$set(item, "cost", parseFloat(row.cost));
            this.$set(item, "amount", parseFloat(row.amount));
        }, // заполнение полей при подготовке к сохранению товаров

        prepareData(val) {
            this.$set(val, "good_type", val.name_ru);
        },

        getFiles(data) {
            this.files = data;
        },

        keyup13: function (event) {
            event.preventDefault();
            // Isolate the node that we're after
            const currentNode = event.target;
            // find all tab-able elements
            const allElements = document.querySelectorAll("input"); // area, object, select, [contenteditable]
            // Find the current tab index.
            const currentIndex = [...allElements].findIndex((el) =>
                currentNode.isEqualNode(el)
            );
            // select/focus the following element
            const targetIndex = (currentIndex + 1) % allElements.length;
            if (targetIndex < allElements.length) {
                allElements[targetIndex].select();
            }
        }, // enter работает как tab

        onCatDataChanged(row) {
            if (Object.keys(row).length === 0) return;
            if (!this.isCatDataValid(row)) return;
            
            this.saveCategoryChanges(row);
        },

        isCatDataValid(row) {
            const isStaffNumValid = this.isFieldValid(row.staff_num);
            const isNameRuValid = !!(row.name_ru && row.name_ru.length > 0);
            const isNameKkValid = !!(row.name_kk && row.name_kk.length > 0);
            const isRowValid = isStaffNumValid && (isNameRuValid || isNameKkValid);
            this.$set(row, 'isRowValid', isRowValid);
            return isRowValid;
        },

        async loadDict() {
            await this.loadMRP();
            this.setFormVersion();
        },

        setFormVersion() {
            this.header.form_version = "02-149_v2";
        },

        async loadMRP() {
            this.mrp = 0;
            try {
                const response = await fetch(
                    `/api-py/dictionary-normative-inds/${this.header.year}/${this.header.cur_year}/${this.header.variant_date_time}`
                );
                const items = await response.json();
                const mrpItem = items.find((item) => item.code === "MRP");
                if (mrpItem) {
                    this.mrp = parseFloat(mrpItem.value);
                }
            } catch (error) {
                this.makeToast(
                    "danger",
                    `${this.getErrText("bad_request")} loadMRP`,
                    error.toString()
                );
            }
        },

        isDecodeDataValid(row) {
            const isCostValid = this.isFieldValid(row.cost);
            const isAmountValid = this.isFieldValid(row.amount);
            const isRowValid = isCostValid && isAmountValid;
            this.$set(row, 'isCostValid', isCostValid);
            this.$set(row, 'isAmountValid', isAmountValid);
            this.$set(row, 'isRowValid', isRowValid);
            return isRowValid;
        },

        ifAllFieldsFilled() {
            const prevNewItemIdx = this.goodsData.findIndex(
                (item) => item.isNew === true
            );
            if (prevNewItemIdx !== -1) {
                const prevNewItem = this.goodsData[prevNewItemIdx];
                if (!prevNewItem.enstru_code) {
                    this.makeToast(
                        "warning",
                        this.getCommonText("attention"),
                        this.getCommonText("not_selected")
                    );
                    return false;
                }
            }
            if (this.goodsData.some((item) => !item.isAmountValid)) {
                this.makeToast(
                    "warning",
                    this.getCommonText("attention"),
                    this.getCommonText("amnt_more_zero")
                );
                return false;
            }
            if (this.goodsData.some((item) => !item.isCostValid)) {
                this.makeToast(
                    "warning",
                    this.getCommonText("attention"),
                    this.getCommonText("cost_more_zero")
                );
                return false;
            }
            if (prevNewItemIdx !== -1)
                this.$set(this.goodsData[prevNewItemIdx], "isNew", false);
            return true;
        }, // проверка заполненности полей у расшифровках

        setDataChanged(val = null) {
            if (val !== null) { this.isDataChanged = val; return; }
            this.isDataChanged = this.goodsData.some(item => item.rowToSave);
        },

        resetModal(bvModalEvent) {
            if (this.isDataChanged && bvModalEvent) {
                bvModalEvent.preventDefault();
                this.onGoodsModalClose();
            } else {
                this.categoryMode = true;
                this.goodsData.splice(0); 
            }
        }, // отчистка 'goods-modal' при закрытии без сохранения

        updateTotalBeforeSave() {
            // отключение метода из миксина
        },

        getFormCode() {
            return "02-149_v2";
        },

        getCodeFieldName() {
            return "category_id";
        },

        async unitsDict() {
            // заглушка, чтобы не загружались единицы измерения
        },

        async updateDatas() {
            this.loadCategoryData();
        },

        isFieldValid(value) {
            return value !== null && value !== '' && value > 0;
        },
    },
    computed: {
        total() {
            let sum = 0;
            for (const row of this.budgetForm) {
                sum += parseFloat(row.total);
            }
            return Math.ceil(sum);
        },

        getFormText() {
            return this.setFormText("form_02_149_v2.");
        },

        tableFields() {
            if (this.$i18n.locale) {
                // EAK-1626: подпись графы сначала ищется в справочнике
                // dict_calculation_form_captions (getCaptionText), а если там для этого
                // caption_key ничего не заведено - используется прежний текст из i18n
                // (fallback). Это НЕ getText()/getFormText()/getCommonText() напрямую -
                // перехват намеренно ограничен только этим местом (заголовки таблицы),
                // см. комментарий у getCaptionText() в bp-i18n-handler-mixin.ts.
                return [
                    {
                        key: "selection",
                        label: " ",
                    },
                    {
                        key: "action",
                        label: " ",
                    },
                    {
                        key: "name",
                        label: this.getCaptionText("name", null, () => this.getCommonText("name")),
                    },
                    {
                        key: "staff_num",
                        label: this.getCaptionText("staff_num", null, () => this.getFormText("staff_num")),
                    },
                    {
                        key: "norm_employee",
                        label: this.getCaptionText("norm_employee", null, () => this.getFormText("norm_employee")),
                    },
                    {
                        key: "norm_division",
                        label: this.getCaptionText("norm_division", null, () => this.getFormText("norm_division")),
                    },

                    {
                        key: "total",
                        label: this.getCaptionText("total", null, () => this.getFormText("total")),
                    },
                    {
                        key: "files",
                        label: this.getCaptionText("files", null, () => this.getCommonText("files")),
                    },
                    {
                        key: "more",
                        label: "",
                    },
                ];
            }
            return [];
        },
        defaultNormEmployee() {
            return this.safeDecimal(this.mrp * 8)
                .round()
                .toNumber();
        },
    },
};
</script>

<style scoped>
.error input {
    padding-left: 25px;
}
.filter-actions-flex {
    display: flex;
}
.table-plus {
    border: none;
}
.bp-category-name {
    display: flex;
    justify-content: space-between;
}
.bp-category-name .icon-pencil-edit {
    align-self: center;
}

.goods-form-val-msg {
    font-size: 0.5rem;
    font-style: italic;
    color: red;
}

.is_custom_norm {
    color: red !important;
}
</style>
